/* eslint-disable react/jsx-key */
import React from 'react';
import { Wrapper } from '../styled';
import { StyledLabel, LoadingWrapper, LoadingIcon } from '../Processing/styled';
import { useIntl } from 'react-intl';
import LoadingGif from 'Images/faraday_loadingbar.gif';
import { getGroupingCommandProgressLabel } from 'Common/Components/FileUploadContext/groupingCommands';

const Uploading = ({ commandType }) => {
  const intl = useIntl();

  const label = () => {
    const groupingLabel = getGroupingCommandProgressLabel(commandType);
    if (groupingLabel) return groupingLabel;
    if (commandType === 'moveAssets') return 'Moving assets...';
    return intl.formatMessage({ id: 'uploadContext.status.uploading' });
  };

  return (
    <Wrapper>
      <StyledLabel children={ label() } />
      <LoadingWrapper children={ <LoadingIcon src={ LoadingGif } /> } />
    </Wrapper>
  );
};

export default Uploading;
